import React from 'react';
import './ShimmerCard.css';

export interface ShimmerCardProps {
  /** Optional CSS class name */
  className?: string;
}

export const ShimmerCard: React.FC<ShimmerCardProps> = ({
  className = '',
}) => {
  const cardClasses = [
    'shimmer-card',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses}>
      {/* Top banner shimmer */}
      <div className="shimmer-card__top-banner shimmer-card__shimmer"></div>

      {/* Header section */}
      <div className="shimmer-card__header">
        <div className="shimmer-card__title-section">
          <div className="shimmer-card__product-name shimmer-card__shimmer"></div>
          <div className="shimmer-card__description shimmer-card__shimmer"></div>
          <div className="shimmer-card__description-line shimmer-card__shimmer"></div>
        </div>
        <div className="shimmer-card__compare-section shimmer-card__shimmer"></div>
      </div>

      {/* Content section */}
      <div className="shimmer-card__content">
        <div className="shimmer-card__image-section shimmer-card__shimmer"></div>
        
        <div className="shimmer-card__details">
          {/* Tags */}
          <div className="shimmer-card__tags">
            <div className="shimmer-card__tag shimmer-card__shimmer"></div>
            <div className="shimmer-card__tag shimmer-card__shimmer"></div>
            <div className="shimmer-card__tag shimmer-card__shimmer"></div>
          </div>

          {/* Match percentage */}
          <div className="shimmer-card__match shimmer-card__shimmer"></div>

          {/* Feature description */}
          <div className="shimmer-card__feature-description shimmer-card__shimmer"></div>
          <div className="shimmer-card__feature-description-line shimmer-card__shimmer"></div>

          {/* Features list */}
          <div className="shimmer-card__features">
            <div className="shimmer-card__features-title shimmer-card__shimmer"></div>
            <div className="shimmer-card__feature-item shimmer-card__shimmer"></div>
            <div className="shimmer-card__feature-item shimmer-card__shimmer"></div>
            <div className="shimmer-card__feature-item shimmer-card__shimmer"></div>
          </div>

          {/* Actions */}
          <div className="shimmer-card__actions">
            <div className="shimmer-card__action-button shimmer-card__shimmer"></div>
            <div className="shimmer-card__action-button shimmer-card__action-button--primary shimmer-card__shimmer"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
